import { ErrorLogComponent } from '@cian/error-log-component';
import { ILogger } from '@cian/logger/shared';
import * as React from 'react';

import { GalleryControlsContainer } from '../../components/OfferGalleryRedesigned/controls/container';
import { GalleryContainer } from '../GalleryContainerRedesigned';
import { MortgagedPropertyLabelsContainer } from '../MortgagedPropertyLabelsContainer';

export interface IOfferGalleryProps {
  reactErrorLogger: ILogger;
  hidePhoneButton?: boolean;
  hideFavoritesButton?: boolean;
}

export class OfferGallery extends React.Component<IOfferGalleryProps, {}> {
  public render() {
    const { reactErrorLogger, hideFavoritesButton, hidePhoneButton } = this.props;

    return (
      <div data-testid="OfferGallery" data-name="OfferGallery" id="photos">
        <ErrorLogComponent logger={reactErrorLogger}>
          <GalleryContainer phoneButton={!hidePhoneButton} favoritesButton={!hideFavoritesButton} />
        </ErrorLogComponent>
        <GalleryControlsContainer />
        <MortgagedPropertyLabelsContainer />
      </div>
    );
  }
}
